package com.essntl.features.crm.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.crm.ui.CRMEvent
import com.essntl.features.crm.ui.CRMNavigation
import com.essntl.features.crm.ui.CRMState
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.uikit.components.button.primary.EsMediumPrimaryButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.toggle.EsTab
import com.essntl.uikit.components.toggle.TabState
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ColumnScope.CRMHeader(
    state: CRMState,
    onEvent: (CRMEvent) -> Unit,
    onNavigation: (CRMNavigation) -> Unit,
) {
    val tabItems = listOf(
        TabState(index = 0, text = "Agencies"),
        TabState(index = 1, text = "Suppliers"),
    )

    Box(
        contentAlignment = Alignment.Center,
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        Text(
            text = "Contacts",
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.h2Bold32,
            modifier = Modifier.align(Alignment.CenterStart),
        )

        EsInput(
            value = state.searchText,
            onValueChange = {
                onEvent(
                    CRMEvent.GetOrganizationList(
                        if (state.selectedContactTab == 0)
                            "travel_agency" else
                            "supplier",
                        it,
                        true,
                    ),
                )
            },
            placeholder = "Search",
            prefix = {
                EsLargeIcon(
                    res = EsIcons.Search,
                )
            },
            singleLine = true,
            modifier = Modifier
                .width(300.dp)
                .align(Alignment.Center),
        )

        Spacer(modifier = Modifier.width(1.spacing))
    }

    Spacer(modifier = Modifier.height(1.spacing))

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                .background(MaterialTheme.esColorScheme.bgSecondary)
                .padding(
                    vertical = EsConstants.SectionVerticalPadding,
                    horizontal = EsConstants.SectionHorizontalPadding,
                ),
        ) {
            EsTab(
                items = tabItems,
                tabWidth = 150.dp,
                selectedItemIndex = state.selectedContactTab,
                onClick = { tabState ->
                    if (state.selectedContactTab == tabState.index ||
                        state.getOrganizationList.isLoading
                    ) return@EsTab

                    onEvent(CRMEvent.Toggle(tabState.index))

                    onNavigation(CRMNavigation.Toggle)
                },
            )

            EsMediumPrimaryButton(
                text = if (state.selectedContactTab == 0)
                    "New Travel Agent" else
                    "New Supplier",
                suffixIconRes = EsIcons.Add,
                onClick = {
                    onNavigation(
                        CRMNavigation.AddOrganization(
                            if (state.selectedContactTab == 0)
                                OrganizationModel.Type.TravelAgency else
                                OrganizationModel.Type.Supplier,
                        ),
                    )
                },
            )
        }
    }
}